import { Route } from 'react-router-dom';

import { RoleDetailPage } from './pages/role-detail-page.js';
import { RoleFormPage } from './pages/role-form-page.js';
import { RoleListPage } from './pages/role-list-page.js';

/**
 * The module's routes, owned by the module.
 *
 * Returned as a fragment of `<Route>` elements so the app's router composes
 * modules rather than enumerating every screen in one file.
 */
export function roleRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/roles" element={<RoleListPage />} />
      {/* Before the parameterised detail route: react-router ranks a static
          segment above a dynamic one, but keeping them in this order means a
          reader does not have to know that to see which wins. */}
      <Route path="/roles/new" element={<RoleFormPage />} />
      <Route path="/roles/:roleId/edit" element={<RoleFormPage />} />
      <Route path="/roles/:roleId" element={<RoleDetailPage />} />
    </>
  );
}
